export function buildAddOnField(schemaFormProvider, sfPathProvider, name, schema, options, type, template) {
	const field = schemaFormProvider.stdFormObj(name, schema, options);

	field.key = options.path;
	field.type = type;
	field.template = template;
	options.lookup[sfPathProvider.stringify(options.path)] = field;

	return field;
}

export function addDefault(schemaFormProvider, schemaType, field) {
	schemaFormProvider.defaults[schemaType] = schemaFormProvider.defaults[schemaType] ?? [];
	schemaFormProvider.defaults[schemaType].unshift(field);
}